export default {
  edit: {
    title: 'edit',
    type: 'object',
    properties: {
      email: {
        type: 'string',
        format: 'email',
      },
      roleId: {
        type: 'string',
        minLength: 1,
      },
    },
    required: ['email', 'roleId'],
  },
};



// WEBPACK FOOTER //
// src/lib/schemas/users_schemas.js